import React from "react";

/**
 * Render the pitchers cell
 *
 * @param game The game to get the stat from
 * @param index The index for the key
 */
export const getPitchersCell = (game: any, index: number) => {
  return (
    <div key={index} className="games-table-column__pitchers-cell">
      {game.awayTeamPitcher ? (
        <span>
          SP {game.awayTeamPitcher?.firstName?.substring(0, 1)}. {game.awayTeamPitcher.lastName}
          <br />
          {game.awayTeamPitcher.wins ?? 0}-{game.awayTeamPitcher.losses ?? 0}
          ,&nbsp;
          {game.awayTeamPitcher.earnedRunAvg ?? "--"} ERA
        </span>
      ) : (
        "Pitcher not announced."
      )}
      <div style={{ height: 10 }} />
      {game.homeTeamPitcher ? (
        <span>
          SP {game.homeTeamPitcher?.firstName?.substring(0, 1)}. {game.homeTeamPitcher.lastName}
          <br />
          {game.homeTeamPitcher.wins ?? 0}-{game.homeTeamPitcher.losses ?? 0}
          ,&nbsp;
          {game.homeTeamPitcher.earnedRunAvg ?? "--"} ERA
        </span>
      ) : (
        "Pitcher not announced."
      )}
    </div>
  );
};
